import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['content', 'container', 'openModalButton', 'textReaderSwitch', 'contrastSwitch', 'fontSizeSelect'];

	connect() {
		let contrastSwitch = this.contrastSwitchTarget;
		let textReaderSwitch = this.textReaderSwitchTarget;

		if (this.getCookie('si-high-contrast') === 'true') {
			document.body.classList.add('si-high-contrast');
			contrastSwitch.setAttribute('data-group-sub-toggle', true);
			contrastSwitch.setAttribute('aria-pressed', 'true');
		}

		if (this.getCookie('si-text-reader') === 'true') {
			textReaderSwitch.setAttribute('data-group-sub-toggle', true);
			textReaderSwitch.setAttribute('aria-pressed', 'true');
			this.textReaderButton(true);
		}

		const savedSize = this.getCookie('si-font-size');

		if (savedSize) {
			document.documentElement.classList.add(`si-${savedSize}-font`);
			this.fontSizeSelectTarget.value = savedSize;
		}
	}

	toggleContrast(e) {
		document.body.classList.toggle('si-high-contrast');

		this.toggleGroupAttributes(e.target, 'group-sub');

		if (this.getCookie('si-high-contrast') !== 'true') {
			this.setCookie('si-high-contrast', 'true', 30);
			e.target.setAttribute('aria-pressed', 'true');
		} else if (this.getCookie('si-high-contrast') === 'true') {
			this.deleteCookie('si-high-contrast');
			e.target.setAttribute('aria-pressed', 'false');
		}
	}

	toggleTextReader(e) {
		this.toggleGroupAttributes(e.target, 'group-sub');

		if (this.getCookie('si-text-reader') !== 'true') {
			this.setCookie('si-text-reader', 'true', 30);
			e.target.setAttribute('aria-pressed', 'true');
			this.textReaderButton(true);
		} else if (this.getCookie('si-text-reader') === 'true') {
			this.deleteCookie('si-text-reader');
			e.target.setAttribute('aria-pressed', 'false');
			this.textReaderButton(false);
		}
	}

	textReaderButton(open) {
		const readTextButton = document.querySelector('#si-accessibility-read-text-button');

		if (open == true) {
			readTextButton.classList.remove('si-accessibility-hidden');
			readTextButton.offsetHeight;
		} else {
			readTextButton.classList.add('si-accessibility-hidden');
		}
	}

	changeFontSize(e) {
		document.documentElement.classList.remove('si-large-font', 'si-xlarge-font');
		const size = e.target.value;

		this.setCookie('si-font-size', size, 30);
		if (size !== 'standard') document.documentElement.classList.add(`si-${size}-font`);
	}

	toggleModal(e) {
		const open = this.openModalButtonTarget.getAttribute('aria-expanded') === 'true';
		this.openModalButtonTarget.setAttribute('aria-expanded', String(!open));

		if (!open) {
			this.contentTarget.classList.remove('si-accessibility-hidden');
			this.contentTarget.offsetHeight;

			this.contentTarget.classList.remove('opacity-0', 'pointer-events-none');

			this.contentTarget.setAttribute('tabindex', '-1');
			this.contentTarget.removeAttribute('aria-hidden');
			this.contentTarget.removeAttribute('inert');
			this.previousFocus = document.activeElement;
			this.contentTarget.focus();
			document.addEventListener('keydown', this.handleKeydown);
			document.addEventListener('click', this.handleOutsideClick, true);
		} else {
			this.contentTarget.classList.add('opacity-0', 'pointer-events-none');
			setTimeout(() => {
				this.contentTarget.classList.add('si-accessibility-hidden');
			}, 300);
			this.contentTarget.removeAttribute('tabindex');
			this.contentTarget.setAttribute('aria-hidden', 'true');
			this.contentTarget.setAttribute('inert', '');
			document.removeEventListener('keydown', this.handleKeydown);
			document.removeEventListener('click', this.handleOutsideClick, true);
			this.previousFocus && this.previousFocus.focus();
		}
	}

	handleOutsideClick = (e) => {
		if (!this.contentTarget.contains(e.target) && !this.openModalButtonTarget.contains(e.target)) {
			this.toggleModal();
		}
	};

	toggleGroupAttributes(element, group) {
		if (element.hasAttribute(`data-${group}-toggle`)) {
			element.removeAttribute(`data-${group}-toggle`);
		} else {
			element.setAttribute(`data-${group}-toggle`, true);
		}
	}

	handleKeydown = (e) => {
		if (e.key === 'Escape') this.toggleModal();
	};

	getCookie(name) {
		const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
		return match ? decodeURIComponent(match[1]) : null;
	}

	setCookie(name, value, days) {
		const expires = new Date(Date.now() + days * 864e5).toUTCString();
		document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
	}

	deleteCookie(name) {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
	}
}
